import { Link } from 'react-router-dom';
import { Row, Col, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { getDashColor } from '../../../shared/components/icons';
import { ICampaignStatsItem } from '../../../types/campaign';

export interface StatsCardProps {
  stat_item: ICampaignStatsItem;
  medProfPending: boolean;
}

export interface StatsSectionProps {
  stat_items: ICampaignStatsItem[];
  medProfPending: boolean;
}

export const StatsCard = ({ stat_item, medProfPending }: StatsCardProps) => {
  const { item_type, title, status, count } = stat_item;

  return (
    <Card
      style={{
        height: '100%',
        borderWidth: '0',
        background: getDashColor(status != '' ? status : item_type),
      }}
    >
      <CardBody className='d-flex flex-column justify-content-between p-3 p-xl-4'>
        <CardTitle
          style={{
            fontWeight: '900',
            fontSize: '14px',
            lineHeight: '16px',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </CardTitle>
        <CardText style={{ fontSize: '20px', fontWeight: '800' }}>
          {status}
        </CardText>
        {medProfPending && item_type === 'disbursements' ? (
          ''
        ) : (
          <>
            <CardText
              style={{
                marginBottom: '16px',
                fontWeight: '500',
                fontSize: '42px',
                lineHeight: '48px',
                color: getDashColor(
                  status != '' ? status : item_type + '_text'
                ),
              }}
            >
              {count}
            </CardText>
            <CardText>
              <Link
                to={
                  item_type === 'disbursements'
                    ? `/${item_type}`
                    : item_type === 'supporters'
                    ? `/campaign/${item_type}/donations`
                    : `campaign/${item_type}`
                }
                style={{
                  color: getDashColor(
                    status != '' ? status : item_type + '_text'
                  ),
                }}
              >
                View All
              </Link>
            </CardText>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export const StatsSection = ({
  stat_items,
  medProfPending,
}: StatsSectionProps) => {
  function showItems() {
    return stat_items.map((item, i) => {
      if (item.item_type === 'disbursements' && medProfPending) {
        item.status = 'Pending Medical Professional Verification';
      }
      return (
        <Col key={i}>
          <StatsCard stat_item={item} medProfPending={medProfPending} />
        </Col>
      );
    });
  }

  return (
    <Row className='row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3 g-md-4 my-1 mt-md-4 mb-5'>
      {showItems()}
    </Row>
  );
};
